const utils = require('frontend-controller/lib/utils')

module.exports = {
    model: {
        availableLangCodes: {}, // serviceConfig defined available langCodes
        routesByRouteID: {},    // sanitized routes by routeID

        routeLanguageConnector: {},         // stores the params given by the calling action
        newRouteLanguageConnections: {},    // stores the definition of changes the user has performed within the gui without saving them.
        performChanges: false,              // is the user ready to save his/her changes

        modalOffsetLevel: 0,    // is used to define the gui offset of cascading languageConnectorModals.
        description: {          // defines the description shown at the top
            class: 'hidden', // hidden, warning, error
            icon: '', // icon class
            content: '', // html content
            contentSuffixHtml: '', // html content suffix
        },

        lastResourceData: {},                   // stores the last used resourceData to be able to reset them in case of misfits or other errors which may occur.
        lastNewRouteLanguageConnections: {},    // stores the last used newRouteLanguageConnections to be able to reset them in case of misfits or other errors which may occur.
    },

    events: {
        click: {
            selector: 'button',
            action: function(event){
                var self = event.data.component;
                var $target = $(event.target).closest('button')
                if($target.length < 1) return;

                var $langNode = $target.closest('.language')
                if($langNode.length < 1) return;

                var langCode        = $langNode.data('langCode')
                var routeID         = $langNode.data('routeId')
                var fieldType       = $target.data('fieldType')
                var buttonContext   = $target.data('buttonContext')
                var buttonMode      = $target.data('buttonMode')

                if(langCode && fieldType && typeof self[fieldType] === 'function') {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    self[fieldType](langCode, buttonContext, buttonMode, routeID);
                }
            }
        }
    },

    methods: {
        onBuild: function(storage){
            if(storage.isClient){
                this.model.routeLanguageConnector = this.getResourceRegisterContent('routeLanguageConnector') || {}
                this.model.modalOffsetLevel = this.model.routeLanguageConnector.modalOffsetLevel || 0
                this.model.availableLangCodes = utils.language.getConfig(storage).available
                this.model.extendByAdminConnectionInformation = this.hasRoleOption('extendRouteLanguageConnectionInformation')
            }
        },

        getResourceFilters: function(storage, resourceFilters, actionKey){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'refreshResources'){
                resourceFilters.mainRouteID = (this.model.routeLanguageConnector || {}).routeID || 0
                resourceFilters.newRouteLanguageConnections = this.model.newRouteLanguageConnections || {}
                resourceFilters.performChanges = this.model.performChanges || false
            }
            return resourceFilters
        },

        sanitizeResources(storage){
            if(this.resourceData.initialized) return;
            this.resourceData.initialized = true;

            this.resourceData.data = this.resourceData.data || {}
            this.resourceData.data.attributes = this.resourceData.data.attributes || {}
            const data = this.resourceData.data.attributes.data = this.resourceData.data.attributes.data || []
            const langCodeMisfits = this.resourceData.data.attributes.langCodeMisfits = this.resourceData.data.attributes.langCodeMisfits || []

            if(this.model.performChanges){
                this.model.performChanges = false;
                if(this.model.modal){
                    this.model.modal.hide(); // TODO: check for side effects from modal animate async
                }
                let statusController;
                if((statusController = getComponent('statusController'))) {
                    statusController.addPanel('status.done.assigned');
                }
                this.triggerClosest('onLanguageConnectorUpdateDone')

            } else {
                var rI, routeAttributes, realLangCode = '', misfitLangCode = '';
                for(rI in langCodeMisfits) {
                    routeAttributes = langCodeMisfits[rI] || {};
                    if(routeAttributes.misfitLangCode){
                        realLangCode    = routeAttributes.langCode
                        misfitLangCode  = routeAttributes.misfitLangCode
                        break;
                    }
                }

                if(misfitLangCode){
                    this.performAction(this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:routeTree.routesLanguageConnectionNotAssignable',
                            variables: {
                                sourceLangCode: misfitLangCode,
                                targetLangCode: realLangCode
                            }
                        }
                    })).then(() => {
                        // reset langCode-connections to original value
                        this.resourceData = utils.simpleCopy(this.model.lastResourceData)
                        this.model.newRouteLanguageConnections = utils.simpleCopy(this.model.lastNewRouteLanguageConnections)
                        this.refresh(false)
                    });
                } else {
                    const usedLangCodes = {}
                    const missingLangCodes = {}
                    const nonUniqueLangCodes = {}
                    this.model.routesByRouteID = {}
                    for(rI in data){
                        routeAttributes = data[rI] || {};
                        this.model.routesByRouteID[routeAttributes.routeID] = routeAttributes
                        if(routeAttributes.langCode){
                            if(usedLangCodes[routeAttributes.langCode]){
                                nonUniqueLangCodes[routeAttributes.langCode] = true
                            }
                            usedLangCodes[routeAttributes.langCode] = true;
                        }
                    }

                    for(var langCode in this.model.availableLangCodes || []){
                        if(!usedLangCodes[langCode]){
                            missingLangCodes[langCode] = true;
                            data.push({
                                langCode,
                                level: 1
                            })
                        }
                    }

                    if(utils.collectionSize(nonUniqueLangCodes) > 0) {
                        this.model.description = {
                            class: 'error',
                            icon: 'fi fi-exclamation-triangle',
                            content: storage.__('error:routeTree:nonUniqueRouteLanguage', {langCodes: Object.keys(nonUniqueLangCodes).join(', ')}),
                            contentSuffixHtml: Object.keys(nonUniqueLangCodes).map(langCode => `<i class="flag-icon ${(this.model.availableLangCodes[langCode] || {}).icon || 'fi fi-flag'}" title="${langCode}"/>`).join('')
                        }
                    } else if(utils.collectionSize(missingLangCodes) > 0){
                        this.model.description = {
                            class: 'warning',
                            icon: 'fi fi-exclamation-triangle',
                            content: storage.__('error:routeTree:missingRoutesLanguageConnections', {langCodes: Object.keys(missingLangCodes).join(', ')}),
                            contentSuffixHtml: Object.keys(missingLangCodes).map(langCode => `<i class="flag-icon ${(this.model.availableLangCodes[langCode] || {}).icon || 'fi fi-flag'}" title="${langCode}"/>`).join('')
                        }
                    } else {
                        this.model.description = {
                            class: 'hidden'
                        }
                    }

                    this.model.lastResourceData = utils.simpleCopy(this.resourceData);
                    this.model.lastNewRouteLanguageConnections = utils.simpleCopy(this.model.newRouteLanguageConnections);
                }

            }
        },

        connectLanguage: function(langCode, buttonContext, buttonMode, routeID){
            var baseActionKey = 'connectLanguage_route'
            if(routeID && this.actions[baseActionKey]) {
                return this.performAndStoreAction(`${baseActionKey}_inEffect`, this.prepareAction(baseActionKey, undefined, {
                    routeLanguageConnector: {
                        routeID,
                        modalOffsetLevel: this.model.modalOffsetLevel + 1
                    }
                }), true);
            }

            return utils.promise.reject();
        },

        open: function(langCode, buttonContext, buttonMode, routeID){
            var routeAttributes = (this.model.routesByRouteID || {})[routeID || 0] || {}
            if(routeAttributes.path){
                const storage = this.getStorage()
                var webServiceUrl = ((storage.app || {}).webService || {}).url;
                if(webServiceUrl){
                    window.open(webServiceUrl + routeAttributes.path, '_blank').focus();
                } else {
                    console.error('LANGUAGE_CONNECTOR_OPEN_ROUTE_WEB_SERVICE_MISSING');
                }
            } else {
                console.error('LANGUAGE_CONNECTOR_OPEN_ROUTE_PATH_MISSING');
            }
        },

        // showEdit: function(langCode, buttonContext, buttonMode){
        //     // console.log('showEdit', langCode, buttonContext, buttonMode)
        // },

        reset: function(langCode, buttonContext, buttonMode, routeID){
            if(langCode){
                if(routeID){
                    this.model.newRouteLanguageConnections = this.model.newRouteLanguageConnections || {}
                    this.model.newRouteLanguageConnections[langCode] = this.model.newRouteLanguageConnections[langCode] || {}
                    this.model.newRouteLanguageConnections[langCode].set = null
                    if(!this.model.newRouteLanguageConnections[langCode].reset){
                        this.model.newRouteLanguageConnections[langCode].without = this.model.newRouteLanguageConnections[langCode].without || {}
                        this.model.newRouteLanguageConnections[langCode].without[routeID] = true
                    }

                    this.refresh()
                }

            } else {
                console.error('LANGUAGE_CONNECTOR_RESET_ROUTE_LANG_CODE_MISSING');
            }
        }
    },

    hooks: {
        attach: function($element, options){
            if(this.model.modalOffsetLevel > 0){
                this.closest('base_modal_modal', function(modal){
                    modal.setOffsetLevel(this.model.modalOffsetLevel);
                })
            }
        },

        onChildChanged: function($element, options){
            options = options || {};

            var langCode = options.fieldCode || '';
            var routeID = Math.abs(Object.keys(options.value || {})[0] || 0);
            if(langCode && routeID){
                this.model.newRouteLanguageConnections = this.model.newRouteLanguageConnections || {}
                this.model.newRouteLanguageConnections[langCode] = this.model.newRouteLanguageConnections[langCode] || {}
                this.model.newRouteLanguageConnections[langCode].without = {}
                this.model.newRouteLanguageConnections[langCode].reset = true
                this.model.newRouteLanguageConnections[langCode].set = routeID
                this.refresh()
            }
        },

        async onDecision($element, options){
            if(options.decisionType !== 'cancel' && (this.model.routeLanguageConnector || {}).routeID && utils.collectionSize(this.model.newRouteLanguageConnections) > 0){
                this.model.performChanges = true
                this.model.modal = options.decisionComponent
                return this.refresh()
            }

            // refresh routeTrees anyway
            await this.triggerClosest('onLanguageConnectorUpdateDone')
            await options.decisionComponent.hide()
        },

        onLanguageConnectorUpdateDone: function($element, options){
            this.refresh();
        }
    }
}